import { Button } from '@material-ui/core'
import AppContext from 'containers/App/Store/AppContext'
import { useMediaQuery } from '../../helpers/PDFFormatter/mediaSize'
import WhiteDollarIcon from '../../assets/icons/Money/white-dollar.svg'

import React, { useContext } from 'react'
import IconText from '../Typography/IconText'
import { amtStr } from '../../helpers/StringNumberFunction/numFormatter'

interface globalStateProps {
  globalState: {
    drawerOpen: boolean
  }
}

interface optionsProps {
  name: string
  onClick: React.MouseEventHandler<HTMLButtonElement>
  disabled?: boolean
  color?: string
  single?: boolean
  props?: any
}
interface IFooterProps {
  options?: optionsProps[]
  title1?: string
  value1?: number
  title2?: string
  value2?: number
}
interface additionalFooterProps {
  width: string
  marginRight?: string
}

export const DynamicFooter = ({
  options,
  title1,
  value1,
  title2,
  value2,
}: IFooterProps) => {
  const { globalState }: globalStateProps = useContext(AppContext as any)
  let single: boolean = false

  if (options?.length === 1) {
    single = true
  }
  const [width] = useMediaQuery() /// hooks monitor browser window width

  const footerWidth = () => {
    let style: additionalFooterProps

    if (globalState.drawerOpen) {
      style = {
        width: 'calc(100% - 298px)',
        marginRight: '29px',
      }
    }
    if (!globalState.drawerOpen) {
      style = {
        width: ' calc(100% - 59px)',
        marginRight: '29px',
      }
    }
    if (width < 600) {
      style = {
        width: '100%',
        marginRight: '0',
      }
    }
    return {
      bottom: '0px',
      transition: 'width 0.2s',
      ...style,
    }
  }

  return (
    <div className="footer" id="footer" style={footerWidth()}>
      <div
        className="footer-label"
        style={{
          background: '#ff9800',
          color: '#fff',
        }}
      >
        <div className="xsTitle flex flex-space">
          <span style={{ paddingRight: '15px' }}>{title1}:</span>
          <span style={{ color: '#fff' }} className="color-primary-orange flex">
            <IconText
              icon={<img src={WhiteDollarIcon} style={{ width: '12px' }} />}
              font="p-l-3"
              childrenStyle={{ color: '#fff' }}
              children={amtStr(value1)}
              parentClassName={`flex-space`}
            />
          </span>
        </div>
        <div className="xsTitle flex">
          <span style={{ paddingRight: '15px' }}>{title2}:</span>
          <span style={{ color: '#fff' }} className="color-primary-orange flex">
            <IconText
              icon={<img src={WhiteDollarIcon} style={{ width: '12px' }} />}
              font="p-l-3"
              childrenStyle={{ color: '#fff' }}
              children={amtStr(value2)}
              parentClassName={`flex-space`}
            />
          </span>
        </div>
      </div>
      <div className="footer-btn">
        {options?.map((el, index) => (
          <Button
            key={index}
            type="submit"
            color={el.color}
            style={{ minWidth: options.length > 2 ? '50px' : '126px' }}
            variant="contained"
            className={single ? 'single' : ''}
            onClick={el.onClick}
            disabled={el.disabled}
            {...el.props}
          >
            {el.name}
          </Button>
        ))}
      </div>
    </div>
  )
}
